<template>
  <div class="elevation-2 px-4 py-4">
    <v-row
      align="center"
      class="mb-2"
    >
      <v-col
        cols="12"
        sm="8"
      >
        <v-text-field
          ref="optionInput"
          v-model="form.text"
          :loading="form.processing"
          :disabled="form.processing"
          :label="$t('Enter option')"
          autocomplete="off"
          hide-details
          outlined
          dense
          @keydown.enter.prevent.stop="handleAddOption"
        />
      </v-col>
      <v-col
        cols="12"
        sm="4"
      >
        <v-btn
          color="primary"
          :loading="form.processing"
          :disabled="form.processing || form.text.length === 0"
          @click="handleAddOption"
        >
          {{ $t('Add') }}
        </v-btn>
      </v-col>
    </v-row>

    <v-list>
      <template v-for="(option, index) in options">
        <v-divider
          v-if="index === 0"
          :key="`div-top-${index}`"
        />
        <v-list-item
          :key="option.id"
          dense
        >
          <v-list-item-title
            class="font-weight-medium"
          >
            {{ option.text }}
          </v-list-item-title>
          <v-list-item-action>
            <v-btn
              icon
              small
              @click.prevent.stop="handleMoveOptionUp(index)"
            >
              <v-icon>
                mdi-arrow-up
              </v-icon>
            </v-btn>
          </v-list-item-action>
          <v-list-item-action>
            <v-btn
              icon
              small
              @click.prevent.stop="handleMoveOptionDown(index)"
            >
              <v-icon>
                mdi-arrow-down
              </v-icon>
            </v-btn>
          </v-list-item-action>
          <v-list-item-action>
            <v-btn
              icon
              small
              @click.prevent.stop="handleDeleteOption(option, index)"
            >
              <v-icon>
                mdi-delete
              </v-icon>
            </v-btn>
          </v-list-item-action>
        </v-list-item>
        <v-divider :key="`div-bottom-${index}`" />
      </template>
      <template v-if="options.length === 0">
        <v-divider />
        <v-list-item>
          <p class="font-italic mb-0">
            {{ $t('No options added') }}
          </p>
        </v-list-item>
        <v-divider />
      </template>
    </v-list>
  </div>
</template>

<script>
import clone from 'lodash/clone';

export default {
  props: {
    faqId: {
      type: Number,
      required: true
    },
    field: {
      type: Object,
      required: false,
      default: null
    },
    mode: {
      type: String,
      required: false,
      default: 'create'
    },
    value: {
      type: Array,
      required: false,
      default: null
    },
  },

  data() {
    return {
      createFieldOptions: this.value,
      form: this.$inertia.form({
        text: '',
      })
    }
  },

  computed: {
    options() {
      if (this.mode === 'edit') {
        return this.field.options.map(option => ({
          text: option.default_translation.text,
          id: option.id
        }));
      } else {
        return this.createFieldOptions;
      }
    }
  },

  methods: {
    handleAddOption() {
      if (this.mode === 'edit') {
        const url = this.route('faq.contact-field.option.store', [this.faqId, this.field.id]);
        this.form.post(url, {
          preserveScroll: true,
          onSuccess: () => {
            this.form.text = '';
            this.$nextTick(() => this.$refs.optionInput.focus());
            this.$emit('refresh-preview');
          }
        });
      } else {
        this.createFieldOptions.push({ text: this.form.text });
        this.form.text = '';
        this.$nextTick(() => this.$refs.optionInput.focus());
        this.$emit('value', this.createFieldOptions);
      }
    },

    handleDeleteOption(option, index) {
      if (this.mode === 'edit') {
        const url = this.route('faq.contact-field.option.destroy', [this.faqId, this.field.id, option.id]);
        this.$inertia.delete(url, {
          preserveScroll: true,
          onSuccess: () => {
            this.$emit('refresh-preview');
          }
        })
      } else {
        this.createFieldOptions.splice(index, 1);
      }
    },

    handleMoveOptionUp(index) {
      if (this.mode === 'edit') {
        const options = clone(this.field.options);
        const toIdx = index === 0 ? options.length : index - 1;
        options.splice(toIdx, 0, options.splice(index, 1)[0]);

        const order = options.map(cat => cat.id);

        const url = this.route('faq.contact-field.option.sort-order.update', [this.faqId, this.field.id]);
        this.$inertia.patch(url, { order }, {
          preserveScroll: true,
          onSuccess: () => {
            this.$emit('refresh-preview');
          }
        });
      } else {
        const toIdx = index === 0 ? this.createFieldOptions.length : index - 1;
        this.createFieldOptions.splice(toIdx, 0, this.createFieldOptions.splice(index, 1)[0]);
      }
    },

    handleMoveOptionDown(index) {
      if (this.mode === 'edit') {
        const options = clone(this.field.options);
        const toIdx = index === options.length - 1 ? 0 : index + 1;
        options.splice(toIdx, 0, options.splice(index, 1)[0]);

        const order = options.map(cat => cat.id);

        const url = this.route('faq.contact-field.option.sort-order.update', [this.faqId, this.field.id]);
        this.$inertia.patch(url, { order }, {
          preserveScroll: true,
          onSuccess: () => {
            this.$emit('refresh-preview');
          }
        });
      } else {
        const toIdx = index === this.createFieldOptions.length - 1 ? 0 : index + 1;
        this.createFieldOptions.splice(toIdx, 0, this.createFieldOptions.splice(index, 1)[0]);
      }
    },
  }
}
</script>